import { Head } from 'features/head'
import { Suspense, lazy } from 'react'

const SeasonsList = lazy(() => import('features/referral-seasons/index'))

export const SeasonsListPage: React.FC = () => {
  return (
    <>
      <Head title='Seasons List' />
      <Suspense fallback={<p>Loading...</p>}>
        <SeasonsList />
      </Suspense>
    </>
  )
}
